var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.035v5.632h.833v1.666H1.667v-1.666H2.5v-5.632A3.747 3.747 0 01.833 7.917c0-.69.187-1.354.528-1.92l2.26-3.914a.833.833 0 01.722-.416h11.315c.298 0 .573.159.722.416l2.252 3.902a3.747 3.747 0 01-1.132 5.05zm-1.667.608a3.747 3.747 0 01-3.125-1.133 3.747 3.747 0 01-5.416.002 3.747 3.747 0 01-3.125 1.132v5.023h11.666v-5.023zM4.824 3.333L2.797 6.844a2.083 2.083 0 003.721 1.847c.28-.698 1.267-.698 1.547 0a2.083 2.083 0 003.87 0c.28-.698 1.267-.698 1.547 0a2.083 2.083 0 103.714-1.86l-2.021-3.498H4.825z",
    fill: "#009EE0",
    fillRule: "nonzero"
  }))));
}
export default SvgIcoShop;